import request from '../utils/request';

// 获取数据统计接口
export function getStatistics() {
  return request({
    url: '/frontExhibitor/index/statistics',
    method: 'get',
  });
}
